"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSsaBadgePopoverWithClassName = exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _Popover = _interopRequireDefault(require("angieslist-react-components/lib/Popover"));

var _angieslistStyles = require("angieslist-styles");

var _strong;

var green = _angieslistStyles.stylesColors.green;

var getSsaBadgePopoverWithClassName = function getSsaBadgePopoverWithClassName() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ssabadge-popover';
  return /*#__PURE__*/(0, _jsx2.default)(_Popover.default, {
    id: "ssabadge-popover",
    className: className
  }, void 0, "A ", _strong || (_strong = /*#__PURE__*/(0, _jsx2.default)("strong", {}, void 0, "Super Service Award")), " goes to providers who have achieved and maintained a superior service rating on Angi.");
};

exports.getSsaBadgePopoverWithClassName = getSsaBadgePopoverWithClassName;

var _default = getSsaBadgePopoverWithClassName();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/SsaBadgePopover/SsaPopover.js
// module id = 3292
// module chunks = 25